'use strict';

module.exports = !('0' in Object('a'));


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/NO_KEYS_IN_STRING_OBJECTS.js
// module id = 462
// module chunks = 0